import React from 'react';
import { FileText, Trash2, Layers, Mail } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент боковой панели с шаблонами
 */
const TemplatesSidebar = ({ 
  emailTemplates, 
  setFormData, 
  setErrors,
  savedTemplates,
  deleteTemplate,
  loadTemplate
}) => {
  // Обработчик применения шаблона из предустановленных
  const handleApplyTemplate = (template) => {
    setFormData(prev => ({
      ...prev,
      subject: template.subject,
      body: template.body
    }));
    setErrors({});
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <FileText className="w-5 h-5 mr-2 text-indigo-500" />
        Шаблоны писем
      </h3>

      {/* Предустановленные шаблоны */}
      <div className="mb-5">
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Популярные шаблоны
        </h4>
        
        <div className="space-y-2">
          {emailTemplates.map((template) => (
            <div 
              key={template.id} 
              className="bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-700 rounded-lg p-3 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
              onClick={() => handleApplyTemplate(template)}
            >
              <div className="flex justify-between items-start">
                <div>
                  <h5 className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-1 flex items-center">
                    <Mail className="w-4 h-4 mr-1.5 text-indigo-500" />
                    {template.name}
                  </h5>
                  <p className="text-xs text-gray-600 dark:text-gray-400 line-clamp-1">
                    {template.subject}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Сохраненные пользователем шаблоны */}
      {savedTemplates && savedTemplates.length > 0 && (
        <div>
          <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center justify-between">
            <span>Ваши шаблоны</span>
            <span className="text-xs text-gray-500 dark:text-gray-400 font-normal">
              {savedTemplates.length} шт.
            </span>
          </h4>
          
          <div className="space-y-2 max-h-64 overflow-y-auto pr-1">
            {savedTemplates.map((template) => (
              <div 
                key={template.id} 
                className="bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800 rounded-lg p-3 hover:bg-indigo-100 dark:hover:bg-indigo-900/30 transition-colors group"
              >
                <div className="flex justify-between items-start">
                  <div className="cursor-pointer" onClick={() => loadTemplate(template.id)}>
                    <h5 className="text-sm font-medium text-indigo-800 dark:text-indigo-300 mb-1">
                      {template.name}
                    </h5>
                    <p className="text-xs text-indigo-600 dark:text-indigo-400 line-clamp-1">
                      {template.formData.subject || '(без темы)'}
                    </p>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Button
                      size="xs"
                      variant="ghost"
                      icon={<Layers className="w-3.5 h-3.5" />}
                      onClick={() => loadTemplate(template.id)}
                      title="Загрузить шаблон"
                    />
                    <Button
                      size="xs"
                      variant="ghost"
                      icon={<Trash2 className="w-3.5 h-3.5 text-red-500" />}
                      onClick={() => deleteTemplate(template.id)}
                      title="Удалить шаблон"
                    />
                  </div>
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  {new Date(template.date).toLocaleDateString('ru-RU')}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Подсказка при отсутствии сохраненных шаблонов */}
      {(!savedTemplates || savedTemplates.length === 0) && (
        <div className="text-sm text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-700/50 p-3 rounded-lg border border-gray-200 dark:border-gray-700">
          <p>У вас пока нет сохраненных шаблонов. После создания ссылки вы можете сохранить её как шаблон для повторного использования.</p>
        </div>
      )}
    </div>
  );
};

export default TemplatesSidebar;